import React, { useContext, useEffect, useState } from 'react';
import './sshomepage.scss';
import AITraining from '../AITraining';
import TeamContainer from '../TeamContainer';
import SubScriptionContainer from '../SubscriptionContainer';
import { bootIntercom, getSessionStorage, setSessionStorage } from '../../utils';
import { getReq, postReq } from '../../utils/api';
import { DOMAIN } from '../../Constants/base';
import { CurrentUserDetails } from '../../context';
import { postLogger } from '../../utils/analytics';
import { trackEvents } from '../../utils/analytics';
import InstallApps from '../InstallApps';

export default function SSHomePage({ trainingRef, salesStackRef }) {
  const userToken = JSON.parse(localStorage.getItem('ss-auth-sales')) || {};

  const [, profileDispatch] = useContext(CurrentUserDetails);
  const profiles = getSessionStorage('current-profile');
  const [userName, setUserName] = useState('');
  const [currentStep, setCurrentStep] = useState(1);
  const [salesToolPlans, setSalesToolPlans] = useState([]);
  //Training data
  const [trainingValues, setTrainingValues] = useState({});

  useEffect(() => {
    getProfile();
  }, []);

  useEffect(() => {
    if (currentStep === 2 && profiles?.userId) trackEvents('view_item_list', { userId: profiles.userId });
  }, [profiles]);

  useEffect(() => {
    if (trainingRef.current) setCurrentStep(1);
  }, [trainingRef]);

  useEffect(() => {
    if (salesStackRef.current) setCurrentStep(2);
  }, [salesStackRef]);

  const getProfile = async () => {
    let url = `${DOMAIN}/v1/user`;
    let requestHeaders = {
      authorization: `bearer ${userToken?.accessToken ? userToken?.accessToken : userToken}`,
    };
    const response = await getReq({ url, requestHeaders });
    const { code, data } = response;
    let timeoutCode = code.toString();
    timeoutCode = Array.from(timeoutCode)[0];
    if (code === 200) {
      setTrainingValues(data.training);
      setUserName(data.name);
      profileDispatch({
        type: 'PROFILE_DETAILS',
        payload: {
          name: data.name,
          email: data.email,
          phoneNo: data.phoneNumber,
          org: data.companyName,
          roleType: data.role,
          role: data.companyRole,
          isAccountSetUp: true,
        },
      });

      setSessionStorage({
        key: 'current-profile',
        value: {
          name: data.name,
          email: data.email,
          phoneNo: data.phoneNumber,
          org: data.companyName,
          roleType: data.role,
          role: data.companyRole,
          isAccountSetUp: true,
          userId: data.userId,
        },
      });
      // getPlans(data?.role);
      bootIntercom(data.name, data.email);
    } else if (timeoutCode === '5') {
      let newPayload = {
        token: userToken?.accessToken ? userToken?.accessToken : userToken,
        code,
      };
      postLogger('GET_USER_DETAILS', newPayload);
    }
  };

  if (profiles) {
    return (
      <div className="ss-home-page">
        {/* <div className="welcome-text">
          <h1>
            <span>Welcome </span> {userName}
            <span>!</span>
          </h1>
        </div> */}
        <div className="app-container">
          <div className="ss-steps">
            <div
              className={currentStep === 1 ? 'ss-step active' : 'ss-step'}
              onClick={() => {
                // Send a custom event
                trackEvents('tap_add_your_team', { userId: profiles.userId });
                setCurrentStep(1);
              }}
            >
              Install Apps
            </div>
            <div
              className={currentStep === 2 ? 'ss-step active' : 'ss-step'}
              onClick={() => {
                setCurrentStep(2);
                trackEvents('view_item_list', { userId: profiles.userId });
              }}
            >
              Manage Subscriptions
            </div>
            <div
              className={currentStep === 3 ? 'ss-step active' : 'ss-step'}
              onClick={() => {
                setCurrentStep(3);
                trackEvents('tap_ai_training', { userId: profiles.userId });
                // Send a custom event
              }}
            >
              Train your AI
            </div>

            <div
              className={currentStep === 4 ? 'ss-step active' : 'ss-step'}
              onClick={() => {
                // Send a custom event
                trackEvents('tap_add_your_team', { userId: profiles.userId });
                setCurrentStep(4);
              }}
            >
              Manage Team
            </div>
          </div>
          <div className={currentStep !== 2 ? 'ss-desc ss-desc-padding' : 'ss-desc'}>
            {currentStep === 1 && (
              <div className="subscriptions">
                <InstallApps setCurrentStep={setCurrentStep} />
              </div>
            )}
            {currentStep === 2 && (
              <div className="subscriptions">
                <SubScriptionContainer setCurrentStep={setCurrentStep} salesToolPlans={salesToolPlans} />
              </div>
            )}
            {currentStep === 3 && (
              <div className="ss-training-container">
                <AITraining getProfile={getProfile} setTabStep={setCurrentStep} trainingValues={trainingValues} />
              </div>
            )}
            {currentStep === 4 && (
              <div className="invite-container">
                <TeamContainer />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
